import { COMMA, ENTER } from '@angular/cdk/keycodes'
import {AfterViewInit,ViewRef, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild,Input, ResolvedReflectiveFactory } from '@angular/core'
import { FormControl } from '@angular/forms'
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA
} from '@angular/material'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { ConsultationService, DialogService, StateService, TiersService, VisiteService, FormulaireService } from '../../../../../services'
import * as moment from 'moment'
import {
	Observable,
	BehaviorSubject,	
} from "rxjs";
import {
    FormDialogFormulaireWithSFComponent
} from "../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component";
import { formatDate } from '@angular/common'

import * as L from '../../../../../../assets/js/leaflet/leaflet'

import {SearchControl,OpenStreetMapProvider,BingProvider } from 'leaflet-geosearch'
                                                 

const KEY = 'map-actions-dialog'



@Component({
	selector: 'atyl-map-dialog',
	templateUrl: './map-dialog.component.html',
	styleUrls: ['./map-dialog.component.scss'],
})
@Stringable({
	path: 'views/partials/content/actions/map-actions-dialog',
	key: KEY
})
export class MapDialog extends BaseDialogComponent implements OnInit,AfterViewInit  {
	

	@StringableValues(KEY) strings: any
	
	@ViewChild('map', { read: undefined, static: undefined }) map: ElementRef<HTMLInputElement>
	
    address:string;
    
    mymap:any;
    provider:any;
    loading:boolean=false;
    
	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<MapDialog>,
		public dialog: MatDialog,
		private stateService: StateService,
		private visiteService: VisiteService,
		private tiersServices: TiersService,
		private consultationService: ConsultationService,
		dialogService: DialogService,
		private formulaireService: FormulaireService,
		private elementRef:  ElementRef,

	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		
		if (this.data.adresse!=undefined) {
			var adresse:any=this.data.adresse;
			var add:any[]=[];
			if (adresse.number!=undefined && adresse.number!='' )
				add.push(adresse.number)
			if (adresse.street!=undefined && adresse.street!='' )
				add.push(adresse.street)	
			if (adresse.town!=undefined && adresse.town!='' ) {
				if (add.length>0)
				 	add.push(",")
				add.push(adresse.town)
				  
			 }  
			this.address=add.join(" ");	
		}
		
		
		 this.mymap = L.map('map');
		 this.mymap.setView([46.8949616,1.1178877,8.46], 5);
		L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
		    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
		}).addTo(this.mymap);
		
		 this.provider = new OpenStreetMapProvider( {
					     params: {
		    'accept-language': 'fr', // render results in Dutch
		    countrycodes: 'fr', // limit search results to the Netherlands
		    addressdetails: 1, // include additional address detail parts
		  },
		});	
		
		/*
		 var BING_KEY =    'AhUGBbh1djAoOXVVgtfUtaINbA2SATHEEKLwvzkzH7JND_H1PxAtWOHLarHDUu5U'
		this.provider =new BingProvider({
			  params: {
			    key: BING_KEY,
			    'accept-language': 'fr', // render results in Dutch
		    	countrycodes: 'fr', // limit search results to the Netherlands
		   		 addressdetails: 1, // include additional address detail parts
			  },
			});
        */
        
		
			
	}
	
	ngAfterViewInit() {
		/*  var s = document.createElement("script");
		  s.type = "text/javascript";
		  s.src = "/client/dist/assets/js/leaflet/plugins/bing/leaflet-bing-layer.js";
		  this.elementRef.nativeElement.appendChild(s);
		*/  
		
		/*var BING_KEY =    'AhUGBbh1djAoOXVVgtfUtaINbA2SATHEEKLwvzkzH7JND_H1PxAtWOHLarHDUu5U'
		console.log("ngAfterViewInit",L.tileLayer.bing)
		L.tileLayer.bing(BING_KEY).addTo(this.mymap) */
		
		//   
		  
		  /*	var roadMutant = L.gridLayer
				.googleMutant({
					maxZoom: 24,
					type: "roadmap",
				})
				.addTo(this.mymap); 
				*/
		
			 
		if (this.address!=undefined
		 && this.address.length>0 )
		  this.loadMap(null);
				
				
		}
	
	
	
	detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
	
	searchEventHandler(result) {
        console.log("searchEventHandler",result);
    }
	
	async loadMap(event:any) {
		this.loading=true;
		var results:any=await this.search();
		console.log("loadmap",results);
		if (results.length>0) {
			var r=results[0];
			var BING_KEY =    'AhUGBbh1djAoOXVVgtfUtaINbA2SATHEEKLwvzkzH7JND_H1PxAtWOHLarHDUu5U'
		   // L2.tileLayer.bing(BING_KEY).addTo(this.mymap) 
			this.mymap.fitBounds(r.bounds);
			
			L.marker([r.y, r.x],
			{
				icon: new L.Icon.Default(),
				title:r.label
				
			}
			).addTo(this.mymap)
		}
		this.loading=false;
		this.detectChanges();
	    /*se.then(function (results:any) {
          console.log('MapDialog search',results)
          
          if (results.length>0) {
			  var r=results[0];
			 this.loading=false;
			 return r;  
          }
			
		});
		*/
	}
	
	search() {
		return this.provider.search({ query: this.address });
		
		
	}
	
}
